/** @file Sorts keys by frame (stable) and keeps only the last key of each frame. */

/** Keys in ascending `f`; when several share a frame, the one listed last in the document wins. */
export function sortKeysByFrame<K extends { f: number }>(keys: readonly K[]): K[] {
  const sorted = [...keys].sort((a, b) => a.f - b.f);
  return sorted.filter((k, i) => sorted[i + 1]?.f !== k.f);
}
